<footer>
  <div class="affinis-footer matero-toolbar mat-toolbar">
    <a
      routerLink="/assets/docs/ANWD_PASM_Energiedashboard_20231208.pdf"
      target="_blank"
      [innerText]="'footer.user_documentation' | translate"
    ></a>
    <a routerLink="/data-privacy" [innerText]="'footer.data_privacy' | translate"></a>
    <span><a href="mailto:support-pasm@affinis.de">Support</a></span>
    <a routerLink="/release-notes">Version 1.0 (01.12.2023)</a>
  </div>
</footer>
